const m = require('minthril');
const { component } = require('../../component');

const Checkbox = component(() => ({
  view: ({ attrs }) => m('label.checkbox', [
    m('input.checkbox__input[type=checkbox]', {
      checked: attrs.checked,
      disabled: attrs.disabled,
      onchange: attrs.onchange
    }),
    m('span.checkbox__control', { 'aria-hidden': 'true' }),
    m('span.checkbox__label', attrs.label)
  ])
}));

module.exports = { Checkbox };
